import { getCurrentUserAddressFromStorage } from './storage';

const parseEnvList = (value: string | undefined): string[] =>
  (value ?? '')
    .split(',')
    .map((item) => item.trim().toLowerCase())
    .filter((item) => item !== '');

export const isTestFeatureToggleEnabled = (): boolean =>
  process.env.REACT_APP_ENABLE_TEST_FEATURE_TOGGLE === 'true';

export const getTestEnabledUsers = (): string[] => parseEnvList(process.env.REACT_APP_TEST_ADDRESSES);

export const getTestEnabledPairs = (): string[] => parseEnvList(process.env.REACT_APP_TEST_PAIRS);

export const getEnabledTestChains = (): string[] => parseEnvList(process.env.REACT_APP_TEST_CHAINS);

export const hasTestFeatureAccess = (
  userAddress: string | undefined = getCurrentUserAddressFromStorage(),
): boolean => {
  if (!isTestFeatureToggleEnabled() || !userAddress) {
    return false;
  }

  return getTestEnabledUsers().includes(userAddress.trim().toLowerCase());
};
